import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-error-screen',
  templateUrl: './error-screen.component.html',
  styleUrls: ['./error-screen.component.css']
})
export class ErrorScreenComponent {
  @Input() title: string = 'Error';
  @Input() description: string = 'Ha ocurrido un problema inesperado. Por favor, inténtalo de nuevo más tarde.';
  @Input() actionLabel: string = 'Reintentar';
  @Input() showAdvisor: boolean = true;
  @Output() close = new EventEmitter<boolean>();
  url: SafeUrl = '';

  constructor(private _loaderService: LoaderService,
              private sanitizer: DomSanitizer,
  ){
    this._loaderService.hide();
  }

  sendWhatsAppMessage() {
    const greeting = 'Hola, necesito tu ayuda para continuar con mi vinculación digital.';
    const errorMessage = ` Me sale el error: ${this.description}. Gracias`;
    const message = encodeURIComponent(`${greeting}${errorMessage}`);
    const phone = localStorage.getItem('phone');

    const url = `https://api.whatsapp.com/send?phone=57${phone}&text=${message}`;

    window.location.href = url;
  }

}